import React from 'react';
import {translateService} from "../../services/TranslateService";
import ApiService from "../../services/api/ApiService";
import "./PaymentCallbacks.scss";
import {useClarityStep} from "../../services/clarity/useClarityStep";
import {formatTemplate} from "../../GetUrlParams";
import { parseRidSession } from "../../interfaces/RidSessionData";

interface ReservationCancelledProps {
    returnToHome: Function;
    apiService: ApiService | undefined;
    pageType: string;
    changeVirtualPageInfo: Function;
}

export default function ReservationCancelled ({ returnToHome, pageType, apiService, changeVirtualPageInfo} : ReservationCancelledProps ) {
    const parsedData = parseRidSession(sessionStorage.getItem('rid-1'));
    let resId = parsedData?.resId;
    const lang = parsedData?.lang ?? 'fi';

    useClarityStep('resCancelled', {
        paymentMethod: parsedData?.paymentMethod,
        city: parsedData?.pickupLoc || '',
        start: parsedData?.startDate || '',
        end: parsedData?.endDate || '',
        loggedIn: parsedData?.li ?? false,
        oneway: parsedData?.returnLoc ? true : undefined,
        resId: String(resId ?? -1),
        resCancelled: true
    });

    React.useEffect(() => {
        if (parsedData) {
            const updatedData = { ...parsedData, cancelled: true };
            sessionStorage.setItem('rid-1', JSON.stringify(updatedData));
        }

        let scrollPoint = document.getElementById("resCancelScrollPoint");
        if (scrollPoint) {
            scrollPoint.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }

        changeVirtualPageInfo('reservationCancelled'); // #TODO: EKI: ADD THIS TO EXPECTED GA EVENTS ONLINE
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const redirectToSameSearch = () => {
        // Build the base URL with the current host and language
        if (!parsedData) {
            returnToHome();
            return;
        }

        // #TODO: test if oneway works in all cases + find way around url param city search

        const baseUrl = `${window.location.origin}/`;
        const startDate = parsedData?.startDate ? parsedData.startDate.replace(/@ /g, '') : '';
        const endDate = parsedData?.endDate ? parsedData.endDate.replace(/@ /g, '') : '';
        const params = new URLSearchParams();

        sessionStorage.removeItem('paymentSuccess'); // prevent redirect loop, user won't see redo payment again
        if (parsedData?.lang && parsedData?.lang !== 'fi') {params.append('lang', 'en');}
        if (startDate) params.append('startdate', startDate);
        if (endDate) params.append('enddate', endDate);
        if (parsedData?.returnLoc) params.append('oneway', '1');
        if (parsedData?.locationSearch) params.append('city', String(parsedData.locationSearch));

        window.location.href = `${baseUrl}?${params.toString()}`;
    }

    function removeResCancelledParam() {
        const url = new URL(window.location.href);
        if (url.searchParams.has('resCancelled')) {
            url.searchParams.delete('resCancelled');
            const newUrl = url.pathname + url.search + url.hash;
            window.history.replaceState({}, '', newUrl);
        }
    }

    const sectionClass = `payment-callback-section py-3 mobile-top-line`;
    return (
        <div className='callback-info-container pb-3' id='resCancelScrollPoint'>
            <div className={sectionClass}>
                <div className="logo-heading-row">
                    <h1 className='payment-callback-heading text-center'>
                        {translateService.translate('paymentCallbackScreens.resCancelledHeading')}
                    </h1>
                </div>
                <span className='text-center'>
                  {formatTemplate(translateService.translate('paymentCallbackScreens.resCancelledText1'),
                      {resId: String(resId ?? '')})}</span>

                <span className='text-center'>
                  {translateService.translate('paymentCallbackScreens.resCancelledText2')}</span>

                <div className='d-flex justify-content-center mb-2 mt-2'>
                    <button className="btn btn-primary btn-outline-primary btn-cta mt-2"
                            onClick={() => {
                                removeResCancelledParam();
                                redirectToSameSearch();
                            }}>
                        {translateService.translate('paymentCallbackScreens.resCancelledBtn1')}
                    </button>
                </div>
                <div className='d-flex justify-content-center'>
                    <button className="btn btn-dark btn-outline-dark btn-cta mt-2"
                            onClick={() => {
                                if (lang === 'en') {window.open('https://www.24rent.fi/en/customer_service/', '_blank')}
                                else {window.open('https://www.24rent.fi/asiakaspalvelu', '_blank')}
                            }}>
                        {translateService.translate('paymentCallbackScreens.contactCustomerService')}
                    </button>
                </div>
            </div>
        </div>
    );
}